// js/sections/CollectionListSection.js
class CollectionListSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {}
  onBlockSelect(event2) {
    const slider = this.querySelector('cos-slider');
    if (slider) {
      slider.scrollToIndex(parseInt(event2.target.getAttribute("data-collection-index")));
    }
  }
}
if (!window.customElements.get("cos-collection-list")) window.customElements.define("cos-collection-list", CollectionListSection);
